import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { ReactComponent as CloseIcon } from '../../../../images/svg/close2.svg'
import Icon from '../../../ui/Icon'

const StyledCloseIcon = styled.div(() => ({
  flex: '0 0 auto',
  width: 8,
  height: 8,
  marginRight: 4,
}))

const StyledText = styled.span(() => ({
  flex: '1 1 auto',
}))

const StyledBadge = styled.div(({ active, theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  margin: `0 ${theme.spaces.default / 2}px ${theme.spaces.default / 4}px 0`,
  padding: `${theme.spaces.default / 4}px ${theme.spaces.default / 2}px`,
  borderRadius: theme.spaces.default * 0.75,
  color: active ? theme.colors.white : theme.colors.mid_grey,
  fontSize: theme.spaces.default * 0.625,
  fontWeight: '800',
  lineHeight: `${theme.spaces.default}px`,
  backgroundColor: active ? theme.colors.primary : theme.colors.transparent,
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  cursor: 'pointer',
  transition: 'background-color .25s',
  WebkitTapHighlightColor: 'transparent',
  userSelect: 'none',
  width: null,
  textAlign: 'center',
}))

const Badge = ({
  active,
  children,
  onClick,
  dataTest,
}) => (
  <StyledBadge onClick={onClick} active={active} data-test={dataTest}>
    {
      active ? (
        <StyledCloseIcon>
          <Icon>
            <CloseIcon />
          </Icon>
        </StyledCloseIcon>
      ) : null
    }
    <StyledText>
      {children}
    </StyledText>
  </StyledBadge>
)

Badge.propTypes = {
  children: PropTypes.string,
  dataTest: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
}

Badge.defaultProps = {
  children: '',
  active: false,
  onClick: () => false,
  dataTest: null,
}

Badge.displayName = 'Badge'
Badge.whyDidYouRender = true

export default React.memo(Badge)
